export { default as PatientDemographics } from './PatientDemographics';
